import { JaneGoldIcon, Tag } from '@iheartjane/reefer';
import type { MarginProperties } from '@iheartjane/reefer';

export interface JaneGoldTagProps extends MarginProperties {
  label: string;
  variant?: 'gold' | 'gold-light';
}
export const JaneGoldTag = ({
  label,
  variant = 'gold',
  ...marginProps
}: JaneGoldTagProps) => {
  return (
    <Tag
      label={label}
      maxLines={1}
      color="grays-black"
      background={variant}
      icon={
        <JaneGoldIcon
          data-testid="jane-gold-icon"
          size="sm"
          mr={variant === 'gold-light' ? 4 : undefined}
        />
      }
      {...marginProps}
    />
  );
};
